import { tFeature } from '../SubscriptionProvider/Subscription.types';

export function findNumericId(feature?: tFeature) {
  return feature?.items?.find((item) => item.id && typeof item.id === 'number')
    ?.id;
}
